import { ReactNode, forwardRef } from "react";
import { cn } from "../lib/utils";

interface BoxProps {
  children: ReactNode;
  boxMainDivClasses?: string;
  boxClass?: string;
}

const Box = forwardRef<HTMLDivElement, BoxProps>(
  ({ children, boxMainDivClasses, boxClass }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("w-full h-auto rounded-2xl overflow-hidden", boxMainDivClasses)}
      >
        <div
          className={cn("w-full h-full bg-surface border border-border rounded-2xl", boxClass)}
        >
          {children}
        </div>
      </div>
    );
  }
);

export default Box;
